// extracted by mini-css-extract-plugin
export default {"wrapper":"jo-z","response":"ko-z","error":"lo-z","disabled":"mo-z","buttons":"no-z","feedbackQuestionSection":"oo-z","yesNoWrapper":"po-z"};